import { ErrorMessage, Field, Form, FormikProvider, useFormik } from 'formik'
import { useEffect, useRef, useState } from 'react'
import { config } from '../../../CommonUtils/CommonURLS'
import { CommonAxiosGet, CommonAxiosPost } from '../../../CommonUtils/CommonAxios'
import * as Yup from 'yup';
import Swal from 'sweetalert2'
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useSelector } from 'react-redux';
import { AC_YEAR_OLD, ERROR_MSG } from '../../../CommonUtils/contextVariables';
import { failureAlert } from '../../../CommonUtils/SweetAlerts';
import { UseGetStatus } from '../../../CommonUtils/Commonstatus';

function PermanentAffiliationofExistingCourses() {
    const [getData, setData] = useState([]);
    const hasFetchedData = useRef(false);
    const coursesFlags = useSelector((state) => state?.commonMastersReducer?.coursesFlags);
    const validationSchema = Yup.object().shape({
        data: Yup.array().when('isPermanentAffiliation', {
            is: 'true',
            then: Yup.array().of(
                Yup.object().shape({
                    afflType21: Yup.string().required(ERROR_MSG).nullable(),
                    yearCourseStart21: Yup.string().when('afflType21', {
                        is: 'Yes',
                        then: Yup.string().required(ERROR_MSG).nullable(),
                        otherwise: Yup.string().notRequired(),
                    }),
                    buildOwnLease21: Yup.string().when('afflType21', {
                        is: 'Yes',
                        then: Yup.string().required(ERROR_MSG).nullable(),
                        otherwise: Yup.string().notRequired(),
                    })
                })
            ),
            otherwise: Yup.array().notRequired(),
        })
    });

    const formik = useFormik({
        initialValues: {
            isPermanentAffiliation: '',
            data: [{
                afflType21: '',
                yearCourseStart21: '',
                buildOwnLease21: '',
                slno: ''
            }]
        },
        validationSchema: validationSchema,
        onSubmit: (val) => {
            if (
                val?.isPermanentAffiliation === "null" ||
                val?.isPermanentAffiliation === undefined ||
                val?.isPermanentAffiliation === ""
            ) {
                Swal.fire({
                    title: 'Required Fields',
                    text: `plesse select  'Is college Applying for Permanent Affiliation to Any Existing courses'`,
                    icon: 'warning',
                    backdrop: false,
                    confirmButtonText: 'OK'
                });
                return;
            }

            let payload = [];

            if (val?.isPermanentAffiliation === "false") {
                payload = [{
                    ...val?.data?.map(row => ({
                        ...row,
                        isPermanentAffiliation: val?.isPermanentAffiliation,
                        afflType21: '',
                        yearCourseStart21: '',
                        buildOwnLease21: '',
                    }))
                }];
            } else {
                // Normal mapping for all rows
                payload = val?.data.map(row => ({
                    ...row,
                    isPermanentAffiliation: val?.isPermanentAffiliation,
                    afflType21: row?.afflType21,
                    yearCourseStart21: row?.yearCourseStart21,
                    buildOwnLease21: row?.buildOwnLease21
                }));
            }


            Swal.fire({
                text: 'Are you sure you want to submit?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, submit it!',
                cancelButtonText: 'No, cancel!',
                backdrop: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    let url = config.url.API_URL + `savePACourses`
                    CommonAxiosPost(url, payload).then((res) => {
                        if (res?.data?.scode === '01') {
                            Swal.fire({
                                text: res?.data?.sdesc,
                                icon: "success",
                                backdrop: true,
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((refresh) => {
                                if (refresh.isConfirmed) {
                                    GetData();
                                    UseGetStatus();
                                }
                            })
                        }
                        else {
                            failureAlert('Failed to Submit')
                        }
                    })
                }
            })
        }
    })

    function GetData() {
        let url = config.url.API_URL + `getPAcourses`;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                let data = res?.data?.getPAcourses
                setData(data)
                let updatedData = data?.length > 0 ? data?.map((ac) => ({
                    isPermanentAffiliation: ac?.isPermanentAffiliation || '',
                    afflType21: ac?.affl_type_21 || '',
                    yearCourseStart21: ac?.year_course_start_21 || '',
                    buildOwnLease21: ac?.build_own_lease_21 || '',
                    slno: ac?.slno
                }
                )) : [{
                    isPermanentAffiliation: '',
                    afflType21: '',
                    yearCourseStart21: '',
                    buildOwnLease21: ''
                }]
                formik?.setFieldValue('data', updatedData)
            }
        })
    }
    const ClearValues = () => {
        if (getData?.length === 0) {
            const defaultValues = [{
                afflType21: '',
                yearCourseStart21: '',
                buildOwnLease21: ''
            }];
            formik?.setFieldValue('data', defaultValues);
        }
    };
    useEffect(() => {
        formik.setFieldValue('isPermanentAffiliation', coursesFlags?.affl_existing_courses_flag?.toString());
        if (!hasFetchedData.current) {
            GetData();
            hasFetchedData.current = true
        }
    }, [coursesFlags])


    return (
        <>
            <FormikProvider value={formik}>
                <Form onChange={formik?.handleChange} onSubmit={formik?.handleSubmit} className='affl-form'>
                    <h5>4. College Application for Permanent Affiliation of Existing courses</h5>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} className='form-control'>
                        <label htmlFor="isPermanentAffiliation" className='me-2'>
                            Is college Applying for Permanent Affiliation to Any Existing courses :
                        </label>
                        <div style={{ marginBottom: '10px' }}>
                            <Field as='select' name='isPermanentAffiliation' className='form-control mt-2' style={{ width: 'auto' }}
                                onChange={(e) => {
                                    if (e?.target?.value === "false") { ClearValues(); }
                                }}>
                                <option value=''>--SELECT--</option><option value="true">Yes</option><option value="false">No</option>
                            </Field>
                            <ErrorMessage name='isPermanentAffiliation' className='text-error' component='div' />
                        </div>
                    </div>
                    {formik?.values?.isPermanentAffiliation === 'true' && getData?.length > 0 && (
                        <>
                            <div className="table-responsive mt-3">
                                <table className="table table-condensed table-bordered table-sm table-responsive affl-table">
                                    <thead>
                                        <tr>
                                            <th>Sno</th>
                                            <th>Academic Program Type</th>
                                            <th>Course /Program</th>
                                            <th>Branch /Combination</th>
                                            <th>Medium</th>
                                            <th>Intake Approved for {AC_YEAR_OLD}</th>
                                            <th>Accreditation Conferred (NBA/NAAC)</th>
                                            <th>Affiliation Valid up to</th>
                                            <th>Applying for Permanent Affiliation</th>
                                            <th>Year of Starting the course</th>
                                            <th>College Building Own/Leased</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {getData.map((ec, i) => (
                                            <tr>
                                                <td>{i + 1}</td>
                                                <td className='text-left'>{ec?.course_group_desc}</td>
                                                <td className='text-left'>{ec?.course_cat_name}</td>
                                                <td className='text-left'>{ec?.course_name}</td>
                                                <td>{ec?.name}</td>
                                                <td>{ec?.final_sanction_intake}</td>
                                                <td>{ec?.accredition}</td>
                                                <td>{ec?.affl_valid_upto ?? '-'}</td>
                                                <td><Field as='select' name={`data[${i}].afflType21`} className='form-control'
                                                    onChange={(e) => {
                                                        if (e.target.value === "No") {
                                                            formik.setFieldValue(`data[${i}].yearCourseStart21`, '');
                                                            formik.setFieldValue(`data[${i}].buildOwnLease21`, '');
                                                        }
                                                    }}
                                                >
                                                    <option value="">--SELECT--</option>
                                                    <option value="Yes">Yes</option>
                                                    <option value="No">No</option>
                                                </Field>
                                                    <ErrorMessage name={`data[${i}].afflType21`} className='text-error' component='div' />
                                                </td>
                                                <td>
                                                    {formik?.values?.data[i]?.afflType21 === 'Yes' && (
                                                        <>
                                                            <Field name={`data[${i}].yearCourseStart21`}>
                                                                {({ field, form }) => (
                                                                    <DatePicker
                                                                        selected={field.value ? new Date(field.value, 0, 1) : null}
                                                                        onChange={(date) => {
                                                                            const year = date ? date.getFullYear().toString() : '';
                                                                            form.setFieldValue(field.name, year);
                                                                        }}
                                                                        showYearPicker
                                                                        dateFormat="yyyy"
                                                                        className="form-control"
                                                                        minDate={new Date(1970, 0, 1)}
                                                                        maxDate={new Date()}
                                                                    />
                                                                )}
                                                            </Field>
                                                            {/* <Field type='text' name={`data[${i}].yearCourseStart21`} onKeyPress={(e) => allowNumbersOnly(e)} maxLength='4' minLength='4' className='form-control' /> */}
                                                            <ErrorMessage name={`data[${i}].yearCourseStart21`} className='text-error' component='div' />
                                                        </>
                                                    )}
                                                </td>
                                                <td>
                                                    {formik?.values?.data[i]?.afflType21 === 'Yes' && (
                                                        <>
                                                            <Field as='select' name={`data[${i}].buildOwnLease21`} className='form-control' >
                                                                <option value="">--SELECT--</option>
                                                                <option value="Own">Own</option>
                                                                <option value="Lease">Lease</option>
                                                            </Field>
                                                            <ErrorMessage name={`data[${i}].buildOwnLease21`} className='text-error' component='div' />
                                                        </>
                                                    )}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </>)}

                    {getData.length > 0 || formik?.values?.isPermanentAffiliation === 'false' ? (<>

                        <button type='submit' className='btn btn-success btn-sm float-end mt-3'>Submit</button><pre /><pre /><pre />
                    </>) : ((<center className='text-danger h5 pt-5'>***** No Data Found *****</center>))}


                </Form>
            </FormikProvider>
        </>
    )
}

export default PermanentAffiliationofExistingCourses